import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';

import Lottie from 'lottie-react';
import { Col, Row, Table, Button } from 'react-bootstrap';
import celebration from 'pages/certifications/emet/wizard/lottie/celebration.json';

import { certificationActions } from 'store/slices/certification/certificationSilce';

import { 
	fetchEmetScores,
	fetchEmetScoreCertificationById
 } from 'api/certifications/emet/scores';


import { handleApiError } from 'utils';

import styles from 'assets/scss/wizard/emetSuccess.module.scss';
import { Card } from 'react-bootstrap';


const ResultEmet = () => {
    console.log('aca');
    const token = useSelector(state => state.authentication.user?.token);
	const dispatch = useDispatch();
	const navigate = useNavigate();

    const location = useLocation();
    const certification = location.state; 

	const [emetScores, setEmetScores] = useState([]);
	const [emetScoreCert, setEmetScoreCert] = useState(0);

	useEffect(() => {
		if (token !== null && token !== undefined)
			loadEmetScores();
	}, [token]); 

	const loadEmetScores = async () => {
        try {
			const { data } = await fetchEmetScores(token);
			if(data?.status === 200) {
				setEmetScores(data.message);
                handleEmetScoreCertificationById();
			}
        } catch (error) {
            handleApiError(error);
        }
    };

	const handleEmetScoreCertificationById = async () => {
        try {
			const { data } = await fetchEmetScoreCertificationById(certification.id, token);
			if(data?.status === 200) {
				setEmetScoreCert(parseInt(data.total_correct_answers));	
			}
        } catch (error) {
            handleApiError(error);
        }
    };

	return (
		<>
			<Card className="mb-3 theme-wizard">
				<Card.Header className="border-bottom border-200">
					<h6 className="mb-0">Resultados</h6>
				</Card.Header>
				<Card.Body>
                    <Row className={styles.centerItems}> {/* Alinea verticalmente */}
                        <Col className="text-center">
                            <div className="wizard-lottie-wrapper">
                                <div className="wizard-lottie mx-auto">
                                    <Lottie animationData={celebration} loop={true} />
                                </div>
                            </div>
                            <h4 className="mb-1">You have finished!</h4>
                            <p className="fs-0">You have successfully completed your test</p>
                            <Button
                                variant="primary"
                                size="lg"
                                onClick={() => {
                                    dispatch(certificationActions.resetCertification()); // Resetea el estado en Redux
                                    navigate('/'); // Redirige a la página principal
                                }}
                                className={`${styles.skipButton}`}>
                                Finished
                            </Button>
                        </Col>

                        <Col md={6}>
                            <Table responsive className="table-lg mt-3">
                                <thead>
                                    <tr>
                                        <th style={{ padding: '15px' }}>Min</th>
                                        <th style={{ padding: '15px' }}>Max</th>
                                        <th style={{ padding: '15px' }}>Title</th>
                                        <th style={{ padding: '15px', textAlign: 'center' }}>Your score</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {emetScores.map((score, index) => {
                                        const isInRange =
                                            Number(emetScoreCert) >= Number(score.min) && Number(emetScoreCert) <= Number(score.max);
                                        return (
                                            <tr className={isInRange ? 'table-success' : 'table-secondary'} key={index}>
                                                <td style={{ fontWeight: isInRange ? 'bold' : 'normal', padding: '15px', textAlign: 'right' }}>
                                                    {score.min}
                                                </td>
                                                <td style={{ fontWeight: isInRange ? 'bold' : 'normal', padding: '15px', textAlign: 'right' }}>
                                                    {score.max}
                                                </td>
                                                <td style={{ fontWeight: isInRange ? 'bold' : 'normal', padding: '15px' }}>
                                                    {score.title}
                                                </td>
                                                <td style={{ textAlign: 'center', fontWeight: isInRange ? 'bold' : 'normal', padding: '15px' }}>
                                                    {isInRange ? emetScoreCert : ''}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
				</Card.Body>
			</Card>
		</>
	);
};

export default ResultEmet;
